import { type ChatSummaryResult } from 'services/api/chat/interfaces';
import { isChatCustomerResult } from 'services/api/interfaces/chat/helpers';

export function getChatsWithCustomers(data: ChatSummaryResult[]): ChatSummaryResult[] {
  return data.filter((chat) => chat.users && chat.users.some(isChatCustomerResult));
}
